import { render, staticRenderFns } from "./MerchantTree.vue?vue&type=template&id=bc73b54c&scoped=true"
import script from "./MerchantTree.vue?vue&type=script&lang=js"
export * from "./MerchantTree.vue?vue&type=script&lang=js"
import style0 from "./MerchantTree.vue?vue&type=style&index=0&id=bc73b54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc73b54c",
  null
  
)

export default component.exports